import { Text } from '@chakra-ui/react';

export const NoTicketsMessage: React.FC<{
  useLearningRegistrationCopy?: boolean;
}> = ({ useLearningRegistrationCopy = false }) => {
  return (
    <Text>
      {useLearningRegistrationCopy
        ? 'Enrollment is not available. Please check back later.'
        : 'Registration is not available. Please check back later.'}
    </Text>
  );
};
